module.exports = __webpack_public_path__ + "static/media/avatar.c05f2fa3.svg";